var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"0.333252","y":"0.727783","width":"24","height":"24","rx":"12","fill":"#D2D2D2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }